import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../../../stylesheets/components/Reports/PositionReports/PnlReport/ConfirmationPopup.scss";
const ConfirmationPopup = (props) => {
    var _a;
    const splitedText = (_a = props === null || props === void 0 ? void 0 : props.description) === null || _a === void 0 ? void 0 : _a.split(". ");
    return (React.createElement("div", { className: "ed-generic-modal-edit" },
        React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
            React.createElement(Modal, { className: `ed-generic-modal ${props.popTitle} `, show: props.show, "data-backdrop": "static", "data-keyboard": "false", centered: true, contentClassName: `${props.popupClass}` },
                React.createElement(Modal.Header, { className: "ed-generic-header", onClick: () => {
                        if (props.setShow)
                            props.setShow(false);
                    } },
                    React.createElement(Modal.Title, null, props.popTitle)),
                React.createElement(Modal.Body, null,
                    props.description && (React.createElement(React.Fragment, null,
                        splitedText[0],
                        ".",
                        React.createElement("br", null),
                        " ",
                        splitedText[1],
                        " ")),
                    props.children),
                props.showFooter && (React.createElement(Modal.Footer, { className: "ed-generic-off-footer" },
                    props.goBackBtn ? (React.createElement(Button, { className: "go-back", onClick: props.btnFirstCta }, props.btnFirstTitle)) : (React.createElement(Button, { className: "review-changes", onClick: props.btnFirstCta }, props.btnFirstTitle)),
                    React.createElement(Button, { className: "confirm", onClick: props.btnSecCta }, props.btnSecTitle)))))));
};
export default ConfirmationPopup;
